import { render, staticRenderFns } from "./GastoAddNew.vue?vue&type=template&id=723674af&"
import script from "./GastoAddNew.vue?vue&type=script&lang=js&"
export * from "./GastoAddNew.vue?vue&type=script&lang=js&"
import style0 from "./GastoAddNew.vue?vue&type=style&index=0&id=723674af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports